'use client'

import { useCallback, useEffect, useState } from 'react'
import debounce from 'lodash.debounce'

import Input from 'shared/ui/form/Input'

import { PriceFilterValidator, PriceType } from '../utils'

import { InputsRow } from './styles'

interface PriceMinMaxInputProps {
  onChange: (prices: PriceType) => void
  minValue: string
  maxValue: string
  debounce?: number
}

export default function PriceMinMaxInput({
  onChange,
  minValue,
  maxValue,
  debounce: debounceTime = 0
}: PriceMinMaxInputProps) {
  const [values, setValues] = useState({ min: minValue, max: maxValue })

  const [error, setError] = useState({
    min: '',
    max: ''
  })

  useEffect(() => {
    setError({ min: '', max: '' })
    setValues({ min: minValue, max: maxValue })
  }, [minValue, maxValue])

  const handleOnChange = useCallback(
    debounce(async (name: string, inputValue: string) => {
      const min = name === 'min' ? inputValue : values.min
      const max = name === 'max' ? inputValue : values.max

      setValues({ min, max })

      const isValidated = PriceFilterValidator.validate({ min, max })

      if (!isValidated)
        return setError(prev => ({
          ...prev,
          [name]: isValidated ? '' : 'Błędna kwota'
        }))

      setError({ min: '', max: '' })
      onChange({ min, max })
    }, debounceTime),
    [debounceTime, values, onChange]
  )

  return (
    <>
      <InputsRow>
        <Input
          noMargin
          key='mobile-min'
          name='min'
          value={values.min}
          placeholder='od'
          type='number'
          inputProps={{ min: 0 }}
          invalid={error.min}
          onChange={handleOnChange}
        />
        -
        <Input
          noMargin
          name='max'
          key='mobile-max'
          inputProps={{ min: 0 }}
          value={values.max}
          placeholder='do'
          onChange={handleOnChange}
          type='number'
          invalid={error.max}
        />
      </InputsRow>
    </>
  )
}
